import { render, staticRenderFns } from "./ClientEditTabInformation.vue?vue&type=template&id=fa0d7f80&"
import script from "./ClientEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports